import React, { useState } from 'react';
import { ChevronLeft, Eye, EyeOff } from 'lucide-react';
type SignInScreenProps = {
  onBack: () => void;
  onSignedIn: () => void;
};
export function SignInScreen({
  onBack,
  onSignedIn
}: SignInScreenProps) {
  const [showPassword, setShowPassword] = useState(false);
  return <section className="h-full overflow-y-auto px-4 pb-5 pt-2 text-white" data-id="element-325" data-mp="vqwnqliaswfg">
      <button onClick={onBack} className="flex items-center rounded-full bg-[#5b5268]/85 px-2 py-1 text-[10px]" data-id="element-326" data-mp="vs7umu71ikas">
        <ChevronLeft className="h-3.5 w-3.5" data-id="element-327" data-mp="31fytxtvzxnz" />
        Back
      </button>

      <h1 className="mt-4 text-lg font-bold" data-id="element-328" data-mp="33sh6c3k4a1k">Sign in</h1>
      <p className="mt-1 text-[9px] text-white/80" data-id="element-329" data-mp="7zr7444ja043">Use your email address and password to continue.</p>

      <form onSubmit={event => {
      event.preventDefault();
      onSignedIn();
    }} className="mt-4 space-y-3" data-id="element-330" data-mp="d0oqgk1a5076">
        <label className="block text-[9px]" data-id="element-331" data-mp="1of28h89cqlfa">
          <span data-id="element-332" data-mp="1odr4p8fwpdo6">Email</span>
          <input required type="email" autoComplete="email" placeholder="Email" className="mt-1 h-8 w-full rounded bg-[#5b5268]/90 px-2 text-[9px] text-white placeholder:text-white/50 outline-none focus:ring-1 focus:ring-white" data-id="element-333" data-mp="1oh5a6pjva2zu" />
        </label>

        <label className="block text-[9px]" data-id="element-334" data-mp="3p4kwvacq15yc">
          <span data-id="element-335" data-mp="3p3jbaby2x12d">Password</span>
          <span className="relative mt-1 block" data-id="element-336" data-mp="3p4cfp69kfehc">
            <input required type={showPassword ? 'text' : 'password'} autoComplete="current-password" placeholder="Password" className="h-8 w-full rounded bg-[#5b5268]/90 px-2 pr-8 text-[9px] text-white placeholder:text-white/50 outline-none focus:ring-1 focus:ring-white" data-id="element-337" data-mp="3k5rhtdhsd6w2" />
            <button type="button" onClick={() => setShowPassword(visible => !visible)} aria-label={showPassword ? 'Hide password' : 'Show password'} className="absolute right-2 top-2" data-id="element-338" data-mp="36c09u9jpdv2g">
              {showPassword ? <EyeOff className="h-3.5 w-3.5" data-id="element-339" data-mp="2mqq8k3ujwq5i" /> : <Eye className="h-3.5 w-3.5" data-id="element-340" data-mp="2munqwn9b1doc" />}
            </button>
          </span>
        </label>

        <button type="submit" className="mt-2 h-10 w-full rounded-md bg-white text-xs font-extrabold text-[#413946]" data-id="element-341" data-mp="2rp1kql8bjcqw">
          SIGN IN
        </button>
      </form>
    </section>;
}